import { useEffect, useState } from 'react';
import api from '../api/client';

// Numero di richieste di supporto "da leggere": per lo staff quelle aperte con l'ultimo messaggio
// dell'utente, per utenti/allenatori quelle con una risposta dello staff non ancora aperta.
// Si aggiorna ogni minuto, quando si torna sulla scheda e dopo ogni lettura/risposta.
export const avvisaTicketCambiati = () => window.dispatchEvent(new Event('ticket-cambiati'));

export default function useTicketDaLeggere(attivo = true) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!attivo) { setN(0); return; }
    let vivo = true;
    const carica = () => api.get('/tickets/conteggio').then(r => { if (vivo) setN(r.data.da_leggere || 0); }).catch(() => {});
    carica();
    const t = setInterval(carica, 60000);
    const onFocus = () => { if (document.visibilityState === 'visible') carica(); };
    window.addEventListener('ticket-cambiati', carica);
    document.addEventListener('visibilitychange', onFocus);
    return () => { vivo = false; clearInterval(t); window.removeEventListener('ticket-cambiati', carica); document.removeEventListener('visibilitychange', onFocus); };
  }, [attivo]);
  return n;
}
